'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
require('../../../../../enums/accordion.js');
require('../../../../../enums/alert.js');
require('../../../../../enums/avatar.js');
require('../../../../../enums/breakpoints.js');
require('../../../../../enums/button.js');
require('../../../../../enums/code-editor.js');
require('../../../../../enums/colors.js');
require('../../../../../enums/combobox.js');
require('../../../../../enums/date.js');
require('../../../../../enums/drag-and-drop.js');
require('../../../../../enums/dialog.js');
require('../../../../../enums/divider.js');
require('../../../../../enums/dropdown.js');
require('../../../../../enums/fieldset.js');
require('../../../../../enums/font-icon.js');
require('../../../../../enums/fonts.js');
require('../../../../../enums/headings.js');
var input = require('../../../../../enums/input.js');
require('../../../../../enums/keys.js');
require('../../../../../enums/list.js');
require('../../../../../enums/listbox.js');
require('../../../../../enums/loader.js');
require('../../../../../enums/margin.js');
require('../../../../../enums/option.js');
require('../../../../../enums/pill.js');
require('../../../../../enums/placements.js');
require('../../../../../enums/popout.js');
require('../../../../../enums/privacy.js');
require('../../../../../enums/radio-group.js');
require('../../../../../enums/status.js');
var _switch = require('../../../../../enums/switch.js');
require('../../../../../enums/table.js');
require('../../../../../enums/tooltip.js');
require('../../../../../enums/transitions.js');
require('../../../../../enums/widths.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const baseName = 'switch';
const keydownKeys = new Set([
    'Enter',
    'Spacebar',
    ' '
]);
/**
 * @deprecated Use `CheckboxSwitch` or `ImmediateSwitch` instead.
 */ const BaseSwitch = ({ children , className , isChecked , isDisabled , labelPosition =input.InputLabelPositions.Left , name , onChange , size =_switch.SwitchSize.Medium , styleClasses , variantName , ...switchProps })=>{
    const handleChange = (e)=>{
        if (isDisabled) return;
        if (onChange && keydownKeys.has(e.key)) onChange(e);
        if (onChange && e.type === 'click') onChange(e);
    };
    return /*#__PURE__*/ React__default.default.createElement("div", _extends({}, switchProps, {
        "aria-checked": isChecked,
        "aria-disabled": isDisabled,
        "aria-label": typeof children === 'string' ? children : name || '',
        className: classnames__default.default(`bf-${baseName}__${variantName}`, styleClasses[variantName], className, styleClasses[labelPosition], styleClasses[size], {
            [styleClasses['no-label']]: !children,
            [styleClasses.checked]: isChecked,
            [styleClasses.disabled]: isDisabled
        }),
        onClick: handleChange,
        onKeyDown: handleChange,
        role: "switch",
        tabIndex: 0
    }), /*#__PURE__*/ React__default.default.createElement("div", {
        className: styleClasses['switch-container']
    }, /*#__PURE__*/ React__default.default.createElement("span", {
        className: styleClasses['switch-container--dot']
    })), /*#__PURE__*/ React__default.default.createElement("div", {
        className: styleClasses['switch-label']
    }, children));
};

exports.BaseSwitch = BaseSwitch;
//# sourceMappingURL=base-switch.js.map
